<div class="row p-5 text-center">
  <img
    src="assets/img/icons/success.svg"
    width="72px"
    height="72px"
    alt="success"
   
  />
  <h2 class="blue-50 bold m-2">Ottimo!</h2>
  <p>La tua richiesta è stata inviata con successo.</p>
</div>
